'use client';
import { DesignSystemError } from '@s7/system';
import { isHex, isRGBA, isRGB } from '../validators/validators.js';

function hexToRgba(color) {
    var hexString = color.replace("#", "");
    if (hexString.length === 3 || hexString.length === 4) {
        hexString = hexString.split("").map(function(char) {
            return "" + char + char;
        }).join("");
    }
    if (hexString.length !== 6 && hexString.length !== 8) {
        console.warn(new DesignSystemError("styles", "Невалидный hex формат. Должно быть 3,4,6 или 8 символов."));
        return {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
    }
    var r, g, b, a = 255;
    var parsed = parseInt(hexString, 16);
    if (hexString.length === 8) {
        r = parsed >> 24 & 255;
        g = parsed >> 16 & 255;
        b = parsed >> 8 & 255;
        a = parsed >> 0 & 255;
    } else {
        r = parsed >> 16 & 255;
        g = parsed >> 8 & 255;
        b = parsed >> 0 & 255;
    }
    var normalizedAlpha = Math.ceil(a * 100 / 255) / 100;
    return {
        r: r,
        g: g,
        b: b,
        a: normalizedAlpha
    };
}
var parseRGBA = function(color) {
    var _color_replace_split_map = color.replace(/[^0-9,.]/g, "").split(",").map(Number), r = _color_replace_split_map[0], g = _color_replace_split_map[1], b = _color_replace_split_map[2], a = _color_replace_split_map[3];
    return {
        r: r,
        g: g,
        b: b,
        a: a || 1
    };
};
var toRGBA = function(color) {
    if (color === "transparent") {
        return {
            r: 0,
            g: 0,
            b: 0,
            a: 0
        };
    }
    if (isHex(color)) {
        return hexToRgba(color);
    }
    if (isRGBA(color) || isRGB(color)) {
        return parseRGBA(color);
    }
    return {
        r: 0,
        g: 0,
        b: 0,
        a: 1
    };
};

export { toRGBA };
